import { FC, useEffect } from 'react'
import {
  Notification as KendoNotification,
  NotificationProps as KendoNotificationProps,
  NotificationEvent
} from '@progress/kendo-react-notification'
import { Slide } from '@progress/kendo-react-animation'
import { Message } from './Message'

interface NotificationProps {
  open: boolean
  id: string
  args: string[]
  duration?: number
  onCloseNotification?: (event?: NotificationEvent) => void
}

export const Notification: FC<NotificationProps> = ({
  open = false,
  id,
  args,
  duration = 5000,
  onCloseNotification
}) => {
  // #region hooks start
  // #endregion hooks end

  // #region useEffect functions start
  useEffect(() => {
    let timer: NodeJS.Timeout | null = null

    if (open && typeof duration === 'number') {
      timer = setTimeout(() => {
        onCloseNotification?.()
      }, duration)
    }

    return () => {
      if (timer !== null) {
        clearTimeout(timer)
      }
    }
  }, [duration, onCloseNotification, open])
  // #endregion useEffect functions end

  // #region logic functions start
  const createNotificationTypeById = (id: string) => {
    const notificationType: KendoNotificationProps['type'] = {
      style: 'none',
      icon: true
    }

    const firstLetter = id.charAt(0)

    if (firstLetter === 'I') {
      notificationType.style = 'info'
    }
    if (firstLetter === 'W') {
      notificationType.style = 'warning'
    }
    if (firstLetter === 'E') {
      notificationType.style = 'error'
    }

    return notificationType
  }

  const handleOnClose = (event: NotificationEvent) => {
    onCloseNotification?.(event)
  }
  // #endregion logic functions end

  // #region render functions start
  return (
    <Slide
      style={{
        position: 'fixed',
        right: 0,
        bottom: 0
      }}
      direction="left"
    >
      {open && (
        <KendoNotification
          closable
          type={createNotificationTypeById(id)}
          onClose={handleOnClose}
        >
          <span>
            {id} <Message id={id} args={args} />
          </span>
        </KendoNotification>
      )}
    </Slide>
  )
  // #endregion render functions end
}
